import React from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import FhirLoader from '../../../../FhirLoader'
import { HealthcareServiceTable } from '@teschglobal/tg-fhir-react-components'
import { HealthcareService } from '@teschglobal/tg-fhir-react-components/dist/types'
import { ProviderResponse } from '../../../../../types/FHIRTypes/ProviderResponse'
import { Organization } from '../../../../../types/FHIRTypes/Organization'

type HealthcareServiceListProps = {
    services: any
    isFetching: boolean
    isLoading: boolean
    isSuccess: boolean
    clickViewDataLink: (service: HealthcareService) => void
    totalPages: number;
    currentPage: number;
    handleChangePage: (page: number) => void
}

const HealthcareServiceList: React.FC<HealthcareServiceListProps> = ({ services, clickViewDataLink, isFetching, isLoading, isSuccess, totalPages, currentPage, handleChangePage }) => {
    const { data: environment } = useEnvironment()
    const rows: HealthcareService[] = services?.data ?? []

    return (
        <>
            <h3>HealthcareService</h3>
            {(isLoading || isFetching) ? (
                <FhirLoader message='Loading...' />
            ) : (
                <>
                    {
                        services?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <span role="status" aria-live="polite">{services?.total.toLocaleString()} record(s) found</span>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                    <HealthcareServiceTable
                        services={rows}
                        onRowLinkClick={clickViewDataLink}
                    />
                    {
                        services?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                </>
            )}
        </>
    )
}

export default HealthcareServiceList
